import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ROUTING } from "../utils/routes";
import { toast } from "react-toastify";
import tokenService from "./token.service";
import { baseUrl } from "./baseUrl";

const AuthService = () => {
  const { userToken, setUserObject } = tokenService();
  const navigate = useNavigate();

  const handleLogin = (data) => {
    return axios.post(`${baseUrl}/users/login`, data);
  };

  const onSuccessLogin = (res, checkVal) => {
    if (res?.data?.success) {
      if (res?.data?.data?.user?.type === 1) {
        let token = res?.data?.data?.token;
        let userData = res?.data?.data?.user;
        userToken(token, checkVal);
        navigate(ROUTING.HOMEPAGE);
        setUserObject(userData, checkVal);
      } else {
        toast.error("You are not allowed to use this site");
      }
    } else {
      toast.error(res.data.message || "Login failed");
    }
  };

  const handleRegister = (data) => {
    return axios.post(`${baseUrl}/users/register`, data);
  };

  const OnSuccessRegister = (res) => {
    if (res?.data?.success) {
      toast.success(
        "Account created successfully, check your email to verify your account"
      );
      navigate(ROUTING.LOGIN);
    }
  };

  const updateFCMService = (token, fcm) => {
    const data = {
      token: fcm,
    };
    return axios.put(`${baseUrl}/users/update-fcm`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  };

  return {
    updateFCMService,
    handleLogin,
    handleRegister,
    onSuccessLogin,
    OnSuccessRegister,
  };
};

export default AuthService;
